import React from 'react';
import classNames from 'classnames';

import { TariffCard, SectionTitle, TextBlock } from '@/ui/index';

import styles from './BannerAzer.module.scss';

const BannerAzer = ({ data }) => {
  return (
    <div
      className={classNames('section', 'wrapper')}
      itemScope
      itemType='http://schema.org/Offer'
    >
      <div className={styles['banner-guest']}>
        <div className={styles['banner-guest__content']}>
          <div className={styles['banner-guest__text']}>
            <div className={styles['banner-guest__subtitle']}>{data?.name}</div>
            <SectionTitle
              titleModify={classNames(
                styles['banner-guest__title'],
                'title--large',
              )}
            >
              {data?.title}
            </SectionTitle>
            <TextBlock className={classNames(styles['banner-guest__desc'])}>
              {data?.description}
            </TextBlock>
          </div>
          <div className={styles['banner-guest__tarrif']}>
            <TariffCard item={data?.tariff} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BannerAzer;
